import React from "react";
import ReactDOM from "react-dom"; // escape hatch for tooltips
import { connect } from "react-redux";

import { Slider, Toggle, NumberInput } from "carbon-components-react";
import { compose, withHandlers } from "recompose";

import { setCityNumber, setCityBoolean } from "../../../store/actions/city";

import {
  getHasCngRegulation,
  getHasMajorHills,
  // Numbers
  getPopulationGrowthRate,
  getEconomicGrowthRate,
  getPopulation,
  getGrossDomesticProduct,
  getPassengerDistanceTraveled,
} from "../../../store/selectors";

const LEVER_TYPE = {
  // Boolean Selectors
  hasMajorHills: "hasMajorHills",
  hasCngRegulation: "hasCngRegulation",
  // City data
  populationGrowthRate: "populationGrowthRate",
  economicGrowthRate: "economicGrowthRate",
  population: "population",
  grossDomesticProduct: "grossDomesticProduct",
  passengerDistanceTraveled: "passengerDistanceTraveled"
};

const LEVER_SELECTOR = {
  [LEVER_TYPE.hasCngRegulation]: getHasCngRegulation,
  [LEVER_TYPE.hasMajorHills]: getHasMajorHills,
  // Demos
  [LEVER_TYPE.populationGrowthRate]: getPopulationGrowthRate,
  [LEVER_TYPE.economicGrowthRate]: getEconomicGrowthRate,
  [LEVER_TYPE.grossDomesticProduct]: getGrossDomesticProduct,
  [LEVER_TYPE.population]: getPopulation,
  [LEVER_TYPE.passengerDistanceTraveled]: getPassengerDistanceTraveled,
};

// Slider Themes
// This is used by both selectors on the page
const makeMapStateToProps = (initialState, initialProps) => {
  const { leverName } = initialProps;
  const selector = LEVER_SELECTOR[leverName];
  const mapStateToProps = (state, props) => {
    return {
      value: selector(state, props), // some number
    }
  }
  return mapStateToProps;
}
const mapDispatchToProps = {
  setCityNumber,
}

// Convert between units of 100 inside...
const PERCENTAGE_SCALE_FACTOR = 100;
const sliderFormat = (value) => {
  return `${value}%`;
}
const BaseSlider = props => (
  <Slider
    value={props.value * PERCENTAGE_SCALE_FACTOR}
    min={-10}
    max={20}
    formatLabel={sliderFormat}
    step={1}
    light={true}
    onChange={props.handleChange}
  />
);

const ConnectedSlider = compose(
  connect(
    makeMapStateToProps,
    mapDispatchToProps
  ),
  withHandlers({
    handleChange: props => event => {
      const { value } = event;
      const { leverName } = props;
      props.setCityNumber(leverName, value / PERCENTAGE_SCALE_FACTOR);
    }
  })
)(BaseSlider);


// Toggle
const BaseToggle = (props) => (
  <Toggle
    labelA="No"
    labelB="Yes"
    onToggle={props.handleChange}
    toggled={props.toggled}
    id={`toggle-${props.leverName}`}
  />
);

const makeMapStateToPropsToggle = (initialState, initialProps) => {
  const { leverName } = initialProps;
  const selector = LEVER_SELECTOR[leverName];

  const mapStateToProps = (state, props) => {
    return {
      toggled: selector(state, props) // some number
    };
  };
  return mapStateToProps;
};

const mapDispatchToPropsToggle = {
  setCityBoolean
};

const ConnectedToggle = compose(
  connect(
    makeMapStateToPropsToggle,
    mapDispatchToPropsToggle,
  ),
  withHandlers({
    handleChange: props => isTrue => { // callback passes boolean directly
      const { leverName } = props;
      props.setCityBoolean(leverName, isTrue);
    }
  })
)(BaseToggle);

// Number Component
const mapDispatchToPropsNumber = {
  setCityNumber
};

const BaseNumberInput = (props) => {
  return <NumberInput
    value={props.value}
    step={props.step}
    onChange={props.handleChange}
  />
}

const ConnectedNumberInput = compose(
  connect(
    makeMapStateToProps,
    mapDispatchToPropsNumber
  ),
  withHandlers({
    handleChange: props => event => {
      const { imaginaryTarget: { value } } = event;
      const { leverName } = props;
      props.setCityNumber(leverName, value);
    }
  })
)(BaseNumberInput);

export { ConnectedSlider, ConnectedToggle, ConnectedNumberInput, LEVER_TYPE } ;



// WEBPACK FOOTER //
// ./src/pages/modelCity/panes/numberSelectors.js